export default function HowItWorksSection() {
  const steps = ['Connect your CRM', 'Call and qualify', 'Book appointments'];
  return (
    <section className="bg-[#fdfcf9] py-5 sm:py-6" aria-label="How it works">
      <ol className="max-w-6xl mx-auto px-6 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm sm:text-base font-medium text-gray-800">
        {steps.map((step, index) => (
          <li key={step} className="flex items-center gap-4">
            {index > 0 && <span aria-hidden="true" className="text-[#8a6414]">→</span>}
            <span id={`how-it-works-step-${index + 1}`}>{step}</span>
          </li>
        ))}
      </ol>
    </section>
  );
}
